import RuejaiClubTierListPage from "./pages/RuejaiClubTierListPage";
import RuejaiClubTierDetailPage from "./pages/RuejaiClubTierDetailPage";

export const ruejaiClubTierRoutes = (prefix = "tiers") => [
  {
    name: "RuejaiClubTierDetailPage",
    path: `${prefix}/:id`,
    component: RuejaiClubTierDetailPage
  },
  {
    name: "RuejaiClubTierListPage",
    path: prefix,
    component: RuejaiClubTierListPage
  }
];
